import PageLoadedQueue
    from "../../../../../../../Solutions.Neos.Site/Resources/Private/Assets/JavaScript/Project/PageLoadedQueue";
import {Modal} from "bootstrap";

export function initSearchModal() {
    const searchModal = document.querySelector('#searchModal') as HTMLElement;
    const searchInput = searchModal.querySelector('#search-modal-term') as HTMLInputElement;
    const recommendedCategoriesList = searchModal.querySelector('#search-modal-recommended-categories') as HTMLElement;
    const uri = searchModal.dataset.searchCategoryUri;
    let controller = null;

    if (!searchModal || !searchInput) {
        console.error('Search modal not found');
        return;
    }

    if (!uri) {
        console.error('Search category URI not found');
        return;
    }

    const modal = new Modal(searchModal, {
        // focus: false,
    });

    const updateRecommendedCategoriesList = async () => {
        showLoading();

        if (controller) {
            controller.abort('Request cancelled due to new request.');
        }
        controller = new AbortController();

        if (!searchInput.value) {
            recommendedCategoriesList.innerHTML = '';
            return;
        }

        const url = new URL(uri, window.location.origin);
        url.searchParams.append('term', searchInput.value);

        const response = await fetch(url, {
            method: 'GET',
            signal: controller?.signal
        });

        if (!response.ok) {
            showError();
            throw new Error('Failed to fetch categories.');
        }

        const content = await response.text();
        if (content === '') {
            showEmptyResults();
            return;
        }
        recommendedCategoriesList.innerHTML = content;
    }

    /**
     * Show the loading template
     */
    const showLoading = () => {
        const template = searchModal.querySelector('#search-modal--loading') as HTMLTemplateElement;

        if (!template) {
            return;
        }

        recommendedCategoriesList.innerHTML = template.innerHTML;
    }

    /**
     * Show the error template
     */
    const showError = () => {
        const template = searchModal.querySelector('#search-modal--error') as HTMLTemplateElement;

        if (!template) {
            return;
        }

        recommendedCategoriesList.innerHTML = template.innerHTML;
    }

    /**
     * Show the empty results template
     */
    const showEmptyResults = () => {
        const template = searchModal.querySelector('#search-modal--empty') as HTMLTemplateElement;

        if (!template) {
            return;
        }

        recommendedCategoriesList.innerHTML = template.innerHTML;
    }

    searchInput.addEventListener('keyup', updateRecommendedCategoriesList);

    const openSearchModalButtons = document.querySelectorAll('[data-open-search-modal="true"]');
    console.log(openSearchModalButtons);
    openSearchModalButtons.forEach((button) => {
        button.addEventListener('click', () => {
            modal.show();
        });
    });

    searchModal.addEventListener('shown.bs.modal', () => {
        searchInput.focus();
    });
}

PageLoadedQueue.addFunction(initSearchModal)
